function FBInit() {
  if (typeof FB == 'object') {
      FB.init({
      appId: gon.facebook_app_id,
      xfbml: true,
      version: 'v5.0'
    });
    $('#permanent').append($('#fb-root').detach());
  }
};

$(document).ready(function() {
  if (gon.facebook_app_id) {
    try {
      $.getScript( "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v5.0", FBInit);
    } catch(e) {
    }
  }
});

$( document ).ready(function() {
  if (typeof FB !== "undefined" && FB !== null) {
    FB.XFBML.parse();
  }
});

$(document).on("turbolinks:before-cache", function () {
  $('[data-turbolinks-no-cache]').remove();
});
